import { useFeature } from '@inflearn/hackle';

export const PHONE_VERIFICATION_SIGNUP_FEATURE_KEY = 263;

// E2E(dev:e2e)는 Hackle 대시보드 값과 무관하게 같은 흐름을 검증해야 해서 env로 강제 ON한다. 운영 env에는 두지 않는다.
const FORCED_ON_FEATURE_KEYS = (process.env.NEXT_PUBLIC_FORCED_ON_FEATURE_KEYS ?? '')
  .split(',')
  .filter(Boolean)
  .map(Number);

/**
 * 가입 시 휴대폰 번호 인증(PLAYER-2842). OFF면 기존처럼 /signup 한 화면에서 약관 동의 후 가입하고,
 * /terms-agreement에서도 번호 인증을 받지 않는다.
 * 모의면접 랜딩의 전화인증도 같은 키로 분기한다(PLAYER-2843). ON이면 /verify/phone으로 이동, OFF면 VerifyPhoneModal.
 */
export const usePhoneVerificationSignupFeature = () => {
  const isFeatureOn = useFeature(PHONE_VERIFICATION_SIGNUP_FEATURE_KEY);

  return {
    isPhoneVerificationSignupFeatureOn:
      isFeatureOn || FORCED_ON_FEATURE_KEYS.includes(PHONE_VERIFICATION_SIGNUP_FEATURE_KEY),
  };
};

export const MOCK_INTERVIEW_PAYMENT_FEATURE_KEY = 264;

export const useMockInterviewPaymentFeature = () => {
  const isFeatureOn = useFeature(MOCK_INTERVIEW_PAYMENT_FEATURE_KEY);

  return { isMockInterviewPaymentFeatureOn: isFeatureOn };
};
